<template>
 
  <div class="collagen">
    <div class="collagen-item">
        <div class="score-left" 
        >{{scoreName}} 
            <span v-if="scoreName=='技巧性'">20%</span>
            <span v-if="scoreName=='多样性'">13.333%</span>
            <span v-if="scoreName=='表演性'">20%</span>
            <span v-if="scoreName=='乐感'">13.3333%</span>
            <span v-if="scoreName=='创意性'">20%</span>
            <span v-if="scoreName=='个性'">13.333%</span>
        </div>
        <div class="progress">
                <span class="num">{{leftScore}}</span>
                <div class="progress-left" :style="leftWidthStyle">
                    <div class="dot"></div>
                </div>
                <div class="progress-right" :style="rightWidthStyle"></div>
                <span  class="num">{{rightScore}}</span>
        </div>
        <div class="right" >
            <span v-if="leftScore>rightScore" class="right-red" :class="leftScore<rightScore?'right-blue':''">{{leftScore-rightScore}}%</span>
            <span v-if="leftScore<rightScore" class="right-red" :class="leftScore<rightScore?'right-blue':''">{{rightScore-leftScore}}%</span>
        </div>
    </div>
</div> 
   
</template>

<script>
export default {
  name:'StreeModalProgress',
  props:['changeScore','scoreName'],
  data () {
    return {
      
    }
  },
  computed:{
    //左边分数
    leftScore (){
      let score=this.changeScore / 100*50+50
      return score
    },
    //右边分数
    rightScore (){
      let score=100-(this.changeScore / 100*50+50)
      return score
    },
    //左边宽度
    leftWidthStyle (){
      let widthStyle={width:this.leftScore*560/100+'px'}
      return widthStyle
    },
    //右边宽度
    rightWidthStyle (){
      let widthStyle={width:this.rightScore*560/100+'px'}
      return widthStyle
    }
  }
}
</script>

<style lang="scss" scoped>
.collagen{
        width: 100%;
        height: 50px;
        .collagen-item{
            display: flex;
            justify-content: space-between;
            .score-left{
                font-weight: bold;
                font-size: 13px;
                width: 140px;
                height: 30px;
                line-height: 30px;
                color: #333333;                      
            }
        //进度条
        .progress{
            width: 100%;
            height:30px;
            line-height:30px;         
            display: flex;
            align-items: center;
            .num{
                display: inline-block;
                width: 60px;
                text-align: center;
                color: #333333;
                font-weight: 500;
            }
            .progress-left{
                background-color: #E51924;
                height: 14px;
                line-height:30px; 
                position: relative;
                .dot{
                    width: 28px;
                    position: absolute;
                    top: -7px;
                    right: -7px;
                    height: 28px;
                    line-height: 26px;
                    background-color: #EDEDED;
                    box-shadow: 0px 2px 4px 0px rgba(26,26,26,0.3);
                    border-radius: 50%;
                }
            }         
            .progress-right{
                background-color: #2773D5;
                height: 14px;
            }
        }
        
        .right{
            width: 54px;
            width: 54px;
            text-align: center;
            color: #ffffff;
            height: 30px;              
            line-height: 30px;
            .right-red{
                display: inline-block;
                width: 100%;
                height: 16px;
                line-height: 16px;
                border-radius: 4px;
                    background: #E51924;
                    font-size: 14px;
            }
            .right-blue{
                background: #2773D5;
            }
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/stree/StreeModalProgress.vue